/* @flow */

import { BUTTON_LAYOUT } from '../../../constants';

import { CLASS } from './class';

export const layoutStyle = `

    .${ CLASS.CONTAINER }.${ CLASS.LAYOUT }-${ BUTTON_LAYOUT.VERTICAL } .${ CLASS.TAGLINE } {
        display: none;
    }
`;
